export class ToastrConstants {
  static readonly error = 'error';
  static readonly success = 'success';
  static readonly warning = 'warn';
  static readonly info = 'info';
  static readonly hidden = 'hidden';
}
